export const JOB_STATUS = [
    {name: 'All', value: ''},
    {name: 'Pending', value: 'pending'},
    {name: 'Processing', value: 'processing'},
    {name: 'Done', value: 'done'},
    {name: 'Error', value: 'error'},
]